const shouldShowProperty = ({ isDisplayed, value }) => isDisplayed && !!value;

export default shouldShowProperty;
